module.exports = __webpack_public_path__ + "img/knu_gallery2.54004e49.jpg";